import {cn} from "#lib/utils";

const FormHeader = ({className, ...props}) =>
  (
    <p className={cn('mb-2 text-lg font-bold', className)} {...props}/>
  );


export default FormHeader;